import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect } from "react";


const OpenCashDrawer = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    
    const dispatch = useAppDispatch();

    useEffect(() => {
        
        
        const action = {
            type: ActionType.OPEN_CASH_DRAWER
        };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));

        }
        
    }, [actionStep, dispatch, id]);

    const tPrefix = "popup.actionBuilder.";

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper">
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Open Cash Drawer" size="xs" weight="medium-heavy"  translatePrefix={tPrefix} />
                        <OliverText text="Allow the user to open the cash drawer during the flow without needing to return to the station home." size="xs" weight="light" translatePrefix={tPrefix} />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={true} label="" value="" custom={false} />
                </div>
                
                
            </div>
        </div>
    );
};
export default OpenCashDrawer;